/* eslint-disable no-restricted-imports */
import {
  IconAdjustmentsHorizontal,
  IconAlertCircle,
  IconAlertOctagon,
  IconAlertTriangle,
  IconAlignLeft,
  IconArrowAutofitWidth,
  IconArrowBack,
  IconArrowDown,
  IconArrowLeft,
  IconArrowMerge,
  IconArrowRight,
  IconArrowUp,
  IconArrowUpRight,
  IconArrowsMaximize,
  IconArrowsSort,
  IconBook2,
  IconBook,
  IconBookFilled,
  IconBookmark,
  IconBookmarkPlus,
  IconBooks,
  IconBriefcase,
  IconBug,
  IconCalendar,
  IconCalendarCheck,
  IconCalendarPlus,
  IconCertificate,
  IconChartBar,
  IconChartRadar,
  IconCheck,
  IconCheckbox,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconCircleCheck,
  IconClick,
  IconClock,
  IconColorPicker,
  IconColumns3,
  IconColumns,
  IconCopy,
  IconDatabase,
  IconDeviceLaptop,
  IconDots,
  IconDotsVertical,
  IconDownload,
  IconEdit,
  IconExternalLink,
  IconEye,
  IconEyeOff,
  IconFile,
  IconFileImport,
  IconFileText,
  IconFileUpload,
  IconFilter2,
  IconFolder,
  IconFolders,
  IconGitMerge,
  IconGripVertical,
  IconHeading,
  IconHeadphones,
  IconHeadphonesFilled,
  IconHeart,
  IconHelpCircle,
  IconHighlight,
  IconHistory,
  IconHome,
  IconHomeCog,
  IconInfoCircle,
  IconKey,
  IconLanguage,
  IconLayoutGrid,
  IconLayoutList,
  IconLayoutSidebar,
  IconLibrary,
  IconLink,
  IconLinkOff,
  IconList,
  IconListNumbers,
  IconLoader2,
  IconLoader,
  IconLock,
  IconLogout,
  IconMail,
  IconMaximize,
  IconMicrophone2,
  IconMicrophone,
  IconMinimize,
  IconMinus,
  IconMoon,
  IconPalette,
  IconPencil,
  IconPhoto,
  IconPin,
  IconPinFilled,
  IconPlayerPause,
  IconPlayerPlay,
  IconPlus,
  IconPointer,
  IconProgress,
  IconRefresh,
  IconReload,
  IconReplace,
  IconReportAnalytics,
  IconRotate2,
  IconRss,
  IconScan,
  IconSearch,
  IconSelector,
  IconServer,
  IconSettings2,
  IconSettings,
  IconSettingsUp,
  IconShield,
  IconSortAscending,
  IconSortAscendingLetters,
  IconSortAscendingNumbers,
  IconSortDescending,
  IconSortDescendingLetters,
  IconSortDescendingNumbers,
  IconSquare,
  IconSquareCheck,
  IconStack2,
  IconStar,
  IconSun,
  IconTag,
  IconTagFilled,
  IconTagMinus,
  IconTagPlus,
  IconTags,
  IconTextCaption,
  IconTextWrap,
  IconTrash,
  IconUpload,
  IconUser,
  IconUsers,
  IconVolume3,
  IconVolume,
  IconVolumeOff,
  IconX,
} from "@tabler/icons-react"

import { IconReadaloud } from "@/components/icons/IconReadaloud"

import { styled } from "./styled"

export const Plus = /*#__PURE__*/ styled(IconPlus)
export const Add = /*#__PURE__*/ styled(IconPlus)
export const Minus = /*#__PURE__*/ styled(IconMinus)
export const Remove = /*#__PURE__*/ styled(IconMinus)
export const Close = /*#__PURE__*/ styled(IconX)
export const Check = /*#__PURE__*/ styled(IconCheck)
export const Checkbox = /*#__PURE__*/ styled(IconCheckbox)
export const Trash = /*#__PURE__*/ styled(IconTrash)
export const Edit = /*#__PURE__*/ styled(IconEdit)
export const Pencil = /*#__PURE__*/ styled(IconPencil)
export const Search = /*#__PURE__*/ styled(IconSearch)
export const Filter = /*#__PURE__*/ styled(IconFilter2)
export const Download = /*#__PURE__*/ styled(IconDownload)
export const Upload = /*#__PURE__*/ styled(IconUpload)
export const Reload = /*#__PURE__*/ styled(IconReload)
export const Refresh = /*#__PURE__*/ styled(IconRefresh)
export const Click = /*#__PURE__*/ styled(IconClick)
export const Link = /*#__PURE__*/ styled(IconLink)
export const LinkOff = /*#__PURE__*/ styled(IconLinkOff)
export const Lock = /*#__PURE__*/ styled(IconLock)
export const Key = /*#__PURE__*/ styled(IconKey)
export const Pin = /*#__PURE__*/ styled(IconPin)
export const PinFilled = /*#__PURE__*/ styled(IconPinFilled)
export const Merge = /*#__PURE__*/ styled(IconArrowMerge)
export const GitMerge = /*#__PURE__*/ styled(IconGitMerge)
export const Copy = /*#__PURE__*/ styled(IconCopy)
export const Replace = /*#__PURE__*/ styled(IconReplace)
export const Upgrade = /*#__PURE__*/ styled(IconSettingsUp)
export const Scan = /*#__PURE__*/ styled(IconScan)
export const Pointer = /*#__PURE__*/ styled(IconPointer)
export const Logout = /*#__PURE__*/ styled(IconLogout)
export const ArrowBack = /*#__PURE__*/ styled(IconArrowBack)
export const Rotate2 = /*#__PURE__*/ styled(IconRotate2)
export const ArrowAutofitWidth = /*#__PURE__*/ styled(IconArrowAutofitWidth)

export const ArrowLeft = /*#__PURE__*/ styled(IconArrowLeft)
export const ArrowRight = /*#__PURE__*/ styled(IconArrowRight)
export const ArrowUp = /*#__PURE__*/ styled(IconArrowUp)
export const ArrowDown = /*#__PURE__*/ styled(IconArrowDown)
export const ArrowUpRight = /*#__PURE__*/ styled(IconArrowUpRight)
export const ChevronDown = /*#__PURE__*/ styled(IconChevronDown)
export const ChevronLeft = /*#__PURE__*/ styled(IconChevronLeft)
export const ChevronRight = /*#__PURE__*/ styled(IconChevronRight)
export const ChevronUp = /*#__PURE__*/ styled(IconChevronUp)
export const Selector = /*#__PURE__*/ styled(IconSelector)
export const Home = /*#__PURE__*/ styled(IconHome)
export const ExternalLink = /*#__PURE__*/ styled(IconExternalLink)

export const Book = /*#__PURE__*/ styled(IconBook2)
export const BookAlt = /*#__PURE__*/ styled(IconBook)
export const BookFilled = /*#__PURE__*/ styled(IconBookFilled)
export const BookmarkPlus = /*#__PURE__*/ styled(IconBookmarkPlus)
export const Books = /*#__PURE__*/ styled(IconBooks)
export const Bookmark = /*#__PURE__*/ styled(IconBookmark)
export const Headphones = /*#__PURE__*/ styled(IconHeadphones)
export const Audiobook = /*#__PURE__*/ styled(IconHeadphones)
export const HeadphonesFilled = /*#__PURE__*/ styled(IconHeadphonesFilled)
export const Microphone = /*#__PURE__*/ styled(IconMicrophone)
export const Microphone2 = /*#__PURE__*/ styled(IconMicrophone2)
export const PlayerPlay = /*#__PURE__*/ styled(IconPlayerPlay)
export const PlayerPause = /*#__PURE__*/ styled(IconPlayerPause)
export const Volume = /*#__PURE__*/ styled(IconVolume)
export const Volume3 = /*#__PURE__*/ styled(IconVolume3)
export const VolumeOff = /*#__PURE__*/ styled(IconVolumeOff)
export const Readaloud = /*#__PURE__*/ styled(IconReadaloud)
export const Image = /*#__PURE__*/ styled(IconPhoto)

export const File = /*#__PURE__*/ styled(IconFile)
export const FileImport = /*#__PURE__*/ styled(IconFileImport)
export const FileText = /*#__PURE__*/ styled(IconFileText)
export const FileUpload = /*#__PURE__*/ styled(IconFileUpload)
export const Database = /*#__PURE__*/ styled(IconDatabase)
export const Server = /*#__PURE__*/ styled(IconServer)
export const Folder = /*#__PURE__*/ styled(IconFolder)

export const Tag = /*#__PURE__*/ styled(IconTag)
export const TagAdd = /*#__PURE__*/ styled(IconTagPlus)
export const TagRemove = /*#__PURE__*/ styled(IconTagMinus)
export const TagFilled = /*#__PURE__*/ styled(IconTagFilled)
export const Tags = /*#__PURE__*/ styled(IconTags)
export const Folders = /*#__PURE__*/ styled(IconFolders)
export const Library = /*#__PURE__*/ styled(IconLibrary)
export const Stack = /*#__PURE__*/ styled(IconStack2)
export const Briefcase = /*#__PURE__*/ styled(IconBriefcase)

export const LayoutGrid = /*#__PURE__*/ styled(IconLayoutGrid)
export const LayoutList = /*#__PURE__*/ styled(IconLayoutList)
export const LayoutSidebar = /*#__PURE__*/ styled(IconLayoutSidebar)
export const Columns = /*#__PURE__*/ styled(IconColumns)
export const Columns3 = /*#__PURE__*/ styled(IconColumns3)
export const List = /*#__PURE__*/ styled(IconList)
export const ListNumbers = /*#__PURE__*/ styled(IconListNumbers)
export const Maximize = /*#__PURE__*/ styled(IconMaximize)
export const ArrowsMaximize = /*#__PURE__*/ styled(IconArrowsMaximize)
export const Minimize = /*#__PURE__*/ styled(IconMinimize)
export const AdjustmentsHorizontal = /*#__PURE__*/ styled(
  IconAdjustmentsHorizontal,
)

export const AlignLeft = /*#__PURE__*/ styled(IconAlignLeft)
export const Heading = /*#__PURE__*/ styled(IconHeading)
export const TextCaption = /*#__PURE__*/ styled(IconTextCaption)
export const TextWrap = /*#__PURE__*/ styled(IconTextWrap)
export const Highlight = /*#__PURE__*/ styled(IconHighlight)

export const User = /*#__PURE__*/ styled(IconUser)
export const Users = /*#__PURE__*/ styled(IconUsers)

export const Calendar = /*#__PURE__*/ styled(IconCalendar)
export const CalendarCheck = /*#__PURE__*/ styled(IconCalendarCheck)
export const CalendarPlus = /*#__PURE__*/ styled(IconCalendarPlus)
export const Clock = /*#__PURE__*/ styled(IconClock)
export const History = /*#__PURE__*/ styled(IconHistory)

export const Progress = /*#__PURE__*/ styled(IconProgress)
export const LoaderIOSish = /*#__PURE__*/ styled(IconLoader)
export const Loader = /*#__PURE__*/ styled(IconLoader2)
export const CircleCheck = /*#__PURE__*/ styled(IconCircleCheck)
export const AlertTriangle = /*#__PURE__*/ styled(IconAlertTriangle)
export const AlertCircle = /*#__PURE__*/ styled(IconAlertCircle)
export const AlertOctagon = /*#__PURE__*/ styled(IconAlertOctagon)
export const InfoCircle = /*#__PURE__*/ styled(IconInfoCircle)
export const Bug = /*#__PURE__*/ styled(IconBug)

export const ChartBar = /*#__PURE__*/ styled(IconChartBar)
export const ChartRadar = /*#__PURE__*/ styled(IconChartRadar)
export const ReportAnalytics = /*#__PURE__*/ styled(IconReportAnalytics)
export const Certificate = /*#__PURE__*/ styled(IconCertificate)

export const ArrowsSort = /*#__PURE__*/ styled(IconArrowsSort)
export const SortAscending = /*#__PURE__*/ styled(IconSortAscending)
export const SortDescending = /*#__PURE__*/ styled(IconSortDescending)
export const SortAlphabeticalAscending = /*#__PURE__*/ styled(
  IconSortAscendingLetters,
)
export const SortAlphabeticalDescending = /*#__PURE__*/ styled(
  IconSortDescendingLetters,
)
export const SortNumericAscending = /*#__PURE__*/ styled(
  IconSortAscendingNumbers,
)
export const SortNumericDescending = /*#__PURE__*/ styled(
  IconSortDescendingNumbers,
)

export const Settings = /*#__PURE__*/ styled(IconSettings)
export const Settings2 = /*#__PURE__*/ styled(IconSettings2)
export const Palette = /*#__PURE__*/ styled(IconPalette)
export const Dropper = /*#__PURE__*/ styled(IconColorPicker)

export const Mail = /*#__PURE__*/ styled(IconMail)
export const Rss = /*#__PURE__*/ styled(IconRss)

export const Shield = /*#__PURE__*/ styled(IconShield)

export const Square = /*#__PURE__*/ styled(IconSquare)
export const SquareCheck = /*#__PURE__*/ styled(IconSquareCheck)

export const Dots = /*#__PURE__*/ styled(IconDots)
export const DotsVertical = /*#__PURE__*/ styled(IconDotsVertical)
export const Eye = /*#__PURE__*/ styled(IconEye)
export const EyeOff = /*#__PURE__*/ styled(IconEyeOff)
export const GripVertical = /*#__PURE__*/ styled(IconGripVertical)
export const Heart = /*#__PURE__*/ styled(IconHeart)
export const HelpCircle = /*#__PURE__*/ styled(IconHelpCircle)
export const Language = /*#__PURE__*/ styled(IconLanguage)
export const Moon = /*#__PURE__*/ styled(IconMoon)
export const DarkMode = /*#__PURE__*/ styled(IconMoon)
export const Sun = /*#__PURE__*/ styled(IconSun)
export const LightMode = /*#__PURE__*/ styled(IconSun)
export const System = /*#__PURE__*/ styled(IconDeviceLaptop)
export const Star = /*#__PURE__*/ styled(IconStar)
export const LibraryDefault = /*#__PURE__*/ styled(IconHomeCog)
